import { Dispatch } from "redux";

export const SHOW_POPUP = "SHOW_POPUP";
export const HIDE_POPUP = "HIDE_POPUP";
export const EDIT_POPUP_TEXT = "EDIT_POPUP_TEXT";

export interface ShowPopupAction {
  type: typeof SHOW_POPUP;
}

export interface HidePopupAction {
  type: typeof HIDE_POPUP;
}

export interface EditPopupAction {
  type: typeof EDIT_POPUP_TEXT;
  body: {
    main: string;
    sub?: string;
  };
}

interface ShowPopup {
  (): (dispatch: Dispatch<ShowPopupAction>) => void;
}

interface HidePopup {
  (): (dispatch: Dispatch<HidePopupAction>) => void;
}

interface ChangePopupText {
  (action: EditPopupAction["body"]): (
    dispatch: Dispatch<EditPopupAction>
  ) => void;
}

export const showPopup: ShowPopup = function () {
  return function (dispatch) {
    dispatch({
      type: SHOW_POPUP,
    });
  };
};

export const hidePopup: HidePopup = function () {
  return function (dispatch) {
    dispatch({
      type: HIDE_POPUP,
    });
  };
};

export const changePopupDescription: ChangePopupText = function (body) {
  return function (dispatch) {
    dispatch({
      type: EDIT_POPUP_TEXT,
      body,
    });
  };
};
